var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff00",
    d: "M0 0h74v74H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0074de"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 23,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 33,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 37,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 39,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 43,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 59,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 61,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 65,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 65,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.93c32aabf3d12fc5a0c5a2461f118d0d.svg";
export { ForwardRef as ReactComponent };